import { Div, Icon, Logo } from '@vgrubs/components';
import styled from 'styled-components';

export const BrandImage = styled.div<{
  borderRadius?: number;
  border?: string;
  $height?: number;
  $width?: number;
  $heightSM?: number;
  $widthSM?: number;
}>`
  position: relative;
  height: ${({ $height }) => ($height ? `${$height}px` : '100px')};
  width: ${({ $width }) => ($width ? `${$width}px` : '100px')};
  border-radius: ${({ borderRadius }) =>
    borderRadius ? `${borderRadius}px` : '50%'};
  overflow: hidden;
  border: ${({ border, theme }) =>
    border ? `${border}` : `1px solid ${theme.primary}`};
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;


  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 800px) {
    height: ${({ $heightSM, $height }) =>
    $heightSM || $height ? `${$heightSM || $height}px` : '100px'};
    width: ${({ $widthSM, $width }) =>
    $widthSM || $width ? `${$widthSM || $width}px` : '100px'};
  }
`;

export const BrandImageComponent = ({
  image,
  Fallback,
  height,
  width,
  heightSM,
  widthSM,
  overlayComponent,
  borderRadius,
  border,
}: {
  image?: string | null | undefined;
  height?: number;
  width?: number;
  heightSM?: number;
  widthSM?: number;
  Fallback?: React.ComponentType<{
    height?: number;
    width?: number;
  }>;
  overlayComponent?: React.ReactNode;
  borderRadius?: number;
  border?: string;
}) => {
  return (
    <BrandImage
      $height={height}
      $width={width}
      $heightSM={heightSM}
      $widthSM={widthSM}
      borderRadius={borderRadius}
      border={border}
    >
      {image ? (
        <img src={image} alt="brand" />
      ) : Fallback ? (
        <Fallback height={height || 100} width={width || 100} />
      ) : (
        <>
          <Icon $size={height || 100} $sizeSM={heightSM || 100}>
            <Logo />
          </Icon>
        </>
      )}
      {overlayComponent && (
        <Div $absolute $top="0" $left="0" $width="100%" $height="100%">
          {overlayComponent}
        </Div>
      )}
    </BrandImage>
  );
};
